import { thousandsSep } from "../Vars/shares";
import Helper from "./Helper";

class Header {
  constructor(config = {}) {
    const {
      submenuSelector,
      submenuTogglerSelector,
      menuTogglerSelector,
      menuContainerSelector,
    } = config;

    this.body = document.querySelector("body");
    this.submenuToggler = document.querySelectorAll(submenuTogglerSelector);
    this.subTogglerArray = Array.prototype.slice.call(this.submenuToggler);
    this.submenuSelector = submenuSelector;
    this.menuToggler = document.querySelector(menuTogglerSelector);
    this.menuContainer = document.querySelector(menuContainerSelector);
    this.submenuOpen = false;
    this.menuOpen = false;

    if (this.submenuToggler.length > 0) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.menuToggler.addEventListener("click", (e) => {
      this.toggleMenu();
    });



    this.subTogglerArray.forEach((toggle) => {
      if(Helper.isDesktop()){
        toggle.addEventListener("mouseenter", (e) => {
          this.nextEnter = true;
          e.preventDefault();
          if(this.menuOpen == false){
            this.toggleSubmenu(toggle);
          }
        });
        toggle.addEventListener("mouseleave", (e) => {
          this.nextEnter = false;
          setTimeout(() => {if(this.nextEnter !== true){
            this.closeAllSubmenus();
          }}, 100);
        });
      } else{
        toggle.addEventListener("click", (e) => {
          e.preventDefault();
          this.toggleSubmenu(toggle);
        }); 
      }

    });

    document.onkeydown = (evt) => {
      evt = evt || window.event;
      var isEscape = false;
      if ("key" in evt) {
        isEscape = evt.key === "Escape" || evt.key === "Esc";
      } else {
        isEscape = evt.keyCode === 27;
      }
      if (isEscape) {
        this.closeAllSubmenus();
        this.menuOpen = true;
        this.toggleMenu();
      }
    };
  }

  toggleMenu() {
    if (this.menuOpen) {
      Helper.removeClass(this.menuToggler, "burger-active");
      Helper.fadeOut(this.menuContainer, 100);
      Helper.removeClass(this.body, "menu-is-open");
      if (document.querySelector(".header-backdrop")) {
        document.querySelector(".header-backdrop").remove();
      }
      this.menuOpen = false;
    } else {
      Helper.addClass(this.menuToggler, "burger-active");
      Helper.fadeIn(this.menuContainer, 100);
      Helper.addClass(this.body, "menu-is-open");
      if (!document.querySelector(".header-backdrop")) {
        let backdrop = document.createElement("div");
        Helper.addClass(backdrop, "header-backdrop");
        this.body.appendChild(backdrop);
        backdrop.addEventListener("click", () => {
          this.toggleMenu();
        });
      }
      this.menuOpen = true;
    }
  }

  closeAllSubmenus() {
    // console.log("close all submenus");
    if(this.nextEnter !== true){
      const submenus = Array.prototype.slice.call(
        document.querySelectorAll(this.submenuSelector)
      );
      Helper.removeClass(this.body, "submenu-is-open");
      submenus.forEach((submenu) => {
        Helper.fadeOut(submenu, 100);
        Helper.removeClass(submenu.parentElement, "submenu-open");
      });
      if (document.querySelector(".header-backdrop")) {
        document.querySelector(".header-backdrop").remove();
      }
      this.submenuOpen = false;
    }
  }

  toggleSubmenu(toggle) {
    const submenus = Array.prototype.slice.call(
      document.querySelectorAll(this.submenuSelector)
    );
    
    const currentSubmenu = toggle.nextElementSibling;
    if(Helper.isDesktop()){
      currentSubmenu.addEventListener('mouseenter', () => {
        this.nextEnter = true;
      });
      currentSubmenu.addEventListener('mouseleave', () => {
        this.nextEnter = false;
        setTimeout(() => {if(this.nextEnter !== true){
          this.closeAllSubmenus();
        }}, 100);
      });
    }
    Helper.fadeToggle(currentSubmenu);
    Helper.toggleClass(currentSubmenu.parentElement, "submenu-open");
    submenus.forEach((submenu) => {
      if (submenu != currentSubmenu) {
        Helper.fadeOut(submenu, 100);
        Helper.removeClass(submenu.parentElement, "submenu-open");
      }
    });
    submenus.forEach((submenu) => {
      if (Helper.hasClass(submenu.parentElement, "submenu-open")) {
        this.submenuOpen = true;
      }
    });
    if (this.submenuOpen) {
      Helper.addClass(this.body, "submenu-is-open");
      if (!document.querySelector(".header-backdrop")) {
        let backdrop = document.createElement("div");
        Helper.addClass(backdrop, "header-backdrop");
        this.body.appendChild(backdrop);
        backdrop.addEventListener("click", () => {
          this.closeAllSubmenus();
        });
      }
      this.submenuOpen = false;
    } else {
      Helper.removeClass(this.body, "submenu-is-open");
      if (document.querySelector(".header-backdrop")) {
        document.querySelector(".header-backdrop").remove();
      }
      this.submenuOpen = true;
    }
  }
}
export default Header;
